import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import VirtualizedSelect from "react-virtualized-select";
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import { fetchFusionCarMakerListInfo } from "../../../../../actions/CM/cm_open_loop/fusionDataCarMakerCollection/dropDownModalAction";
import {
    cartCountUpdate, selectedScenarioUuidList,
    selectedScenarioNameList,
    bulkSelectedScenarioList,
    cartCount,
    setCurrentPageNumber,
} from "../../../../../actions/CM/cm_open_loop/fusionDataCarMakerCollection/addToCartFusionDataCollectionAction";
function filterSearchingModel(props) {
    useEffect(() => {
        const key = {
            total_variation_count: 0,
            data: []
        }
        props.variationFusionCarMakerList(key);
        const obj = {
            count: 0,
            items: [],
        };
        props.cartCountUpdate(obj);
        props.selectedScenarioUuidList([]);
        props.selectedScenarioNameList([]);
    }, []);

    const [conditionValueOptions, setConditionValueOptions] = useState([]);
    const [isValueSelected, setIsValueSelected] = useState(false);
    const [filterObject, setFilterObject] = useState({});
    const [filters, setFilters] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [newFilter, setNewFilter] = useState({ api: '', condition: '', value: '' });
    const [availableConditions] = useState([
        { api: '/cm/close_loop/fetch-carmaker_model_record', name: "model_name", label: 'Model_Version', value: 'model_name' },
        { api: '/cm/close_loop/fetch-carmaker_assessment_code_record', label: 'Assessment Type', value: 'assessment_type_name' },
        { api: '/cm/close_loop/fetch-carmaker_scenario_type_record', label: 'Scenario_Type', value: 'scenario_type_name' },
        { api: '/cm/close_loop/carmaker_situation1_record', label: 'Situation_1', value: 'situation1_type_name' },
        { api: '/cm/close_loop/carmaker_situation2_record', label: 'Situation_2', value: 'situation2_type_name' },
    ])

    useEffect(() => {
        const fetchConditionValueOptions = async () => {
            console.log(newFilter, "lll")
            if (newFilter.condition) {
                try {
                    const response = await axios.get(`${newFilter.api.toLowerCase()}`);
                    setConditionValueOptions(response.data);
                } catch (error) {
                    console.error('Error fetching condition value options:', error);
                }
            }
        };

        fetchConditionValueOptions();
    }, [newFilter.condition]);

    const handleConditionChange = (event) => {
        const condition = event.target.value;
        const selectedOption = event.target.selectedOptions[0];
        const api = selectedOption.getAttribute('data-api');
        setNewFilter({ ...newFilter, api, condition, value: '' });
    };

    const handleValueChange = (e) => {
        const value = e.target.value;
        setIsValueSelected(value !== "");
        setNewFilter({ ...newFilter, value });
    };
    const handleAddFilter = () => {
        setIsValueSelected(false)
        setFilters([...filters, newFilter]);
        let newFilterObj = {};
        console.log(filters, "vvv")
        filters.forEach(filter => {
            newFilterObj[filter.condition] = filter.value;
        });
        setFilterObject(newFilterObj);
        setNewFilter({ api: '', condition: '', value: '' });

    };
    const handleRemoveFilter = (index) => {
        setFilters(filters.filter((_, i) => i !== index));
    };
    const handleCloseModal = () => {
        setShowModal(false);
    };
    return (
        <div className="col-lg-12" style={{ paddingLeft: '100px' }} >
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="condition">
                        <Form.Label>Condition</Form.Label>
                        <Form.Control as="select" value={newFilter.condition} onChange={(event) => handleConditionChange(event)}>
                            <option value="">Filtering Condition</option>
                            {availableConditions.map((option) => (
                                <option key={option.value} value={option.value} data-api={option.api}>
                                    {option.label}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                    {newFilter.condition && (
                        <Form.Group controlId="value">
                            <Form.Label>Value</Form.Label>
                            <Form.Control as="select" value={newFilter.value} onChange={handleValueChange}>
                                <option value="">select.....</option>
                                {conditionValueOptions.map((option, index) => (
                                    !filters.find(filter => filter.value === option) &&
                                    <option key={index} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    )}

                    {filters.length > 0 && (
                        <div>
                            <h4>Current Filters:</h4>
                            {filters.map((filter, index) => (
                                <div key={index}>
                                    {filter.condition}: {filter.value}
                                    <button onClick={() => handleRemoveFilter(index)} >X</button>

                                </div>
                            ))}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleAddFilter} disabled={!isValueSelected}>
                        Add Filter
                    </Button>
                </Modal.Footer>
            </Modal>



            {/* <input
                style={{ width: '80%', height: '60px', borderRadius: '10px' }}
                type="text"
                value={filters.map(filter => `${filter.condition}: ${filter.value}`).join(', ')}
                onClick={handleShowModal}


                placeholder="Click here to select values"

            /> */}
            {/* <button onClick={submitDropDownMenu} style={{ height: '60px',cursor:'pointer', marginLeft: '15px', borderRadius: '10px' }}>Search</button>
            <Link
                    to={{
                        pathname:
                            "/close_loop_scenario_collection_enhanced/cm_scenario_file/upload",
                    }}
                    style={{ textDecoration: "none" }}>
                    
                    <button style={{ height: '60px', marginLeft: '15px',cursor:'pointer', borderRadius: '10px' }}>
                        Upload Scenario
                        <i
                            className="fa fa-upload"
                            aria-hidden="true"
                            style={{ margin: "0rem 0.5rem" }}
                        ></i>    
                    </button>    

            </Link>                       */}
            <div style={{ marginTop: '10px', marginLeft: '50px' }}>
           {/* change for the label name */}
                <tr style={{ display: 'flex' }}>
                    {filters.map((filter, index) => (
                        <div key={index} style={{ marginRight: '10px', marginBottom: '10px', padding: '5px', border: '1px solid #757AF7', borderRadius: '5px' }}>
                            {filter.label}
                            {filter.condition}: {filter.value}
                            <button onClick={() => handleRemoveFilter(index)}>X</button>
                        </div>
                    ))}
                </tr>

            </div>

            <div >

            </div>

        </div>
    );
}

const mapStateToProps = (state) => ({
    variationInfo: state.DropDownSubmitCarMakerFusionReducer.variationListInfo1,
    scenarioObjectListData: state.addBulkScenariosToListStatus.selectedScenarioObjectList,
    count: state.addToCartScenarioCollectionData.count,

});

const mapDispatchToProps = (dispatch) => ({
    variationFusionCarMakerList: (setPayloadForScenarioListing, page) => dispatch(fetchFusionCarMakerListInfo(setPayloadForScenarioListing, page)),
    cartCountUpdate: (obj) => dispatch(cartCountUpdate(obj)),
    selectedScenarioUuidList: (variationUuid) => dispatch(selectedScenarioUuidList(variationUuid)),
    selectedScenarioNameList: (variationName) => dispatch(selectedScenarioNameList(variationName)),
    bulkSelectedScenarioList: (scenarioObject) =>
        dispatch(bulkSelectedScenarioList(scenarioObject)),
    cartCount: (variationCount) => dispatch(cartCount(variationCount)),
    setCurrentPageNumber: (currentPageNumber) => dispatch(setCurrentPageNumber(currentPageNumber)),
});

export default connect(mapStateToProps, mapDispatchToProps)(filterSearchingModel);